import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Select,
  Upload,
  message,
  notification,
} from "antd";
import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo.png";
import { createSet } from "../../firebase/fireStore";
import { generarId } from "../../utils/generarld";
import FirebaseApp from "../../firebase/context";
import uploadImageToFirebase from "../../firebase/uploadImageToFirebase";
import { MyUpload } from "../../firebase/MyUpload";
const UpTest = () => {
  const { Header } = Layout;
  const { Option } = Select;
  const [imageUrl, setImageUrl] = useState(null);
  console.log("...lik" + imageUrl);
  const [imageRef, setImageRef] = useState(null);
  const onFinish = async (value) => {
    const { anxiety, bad, good, level, email } = value;
    const { data, isError, message } = await createSet(
      "test",

      {
        anxiety,
        bad,
        chart: imageUrl,
        good,
        level,
        email,
        time: FirebaseApp.firestore.Timestamp.fromDate(new Date()),
      },
      generarId()
    );
    !isError
      ? console.log(data)
      : isError({
          message,
          show: true,
        });
    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          window.location.reload(true);
        }}
      >
        OK
      </Button>
    );
    notification.open({
      message: "Test enviado correctamente",
      btn,
    });
  };

  const handleImageUpload = (file) => {
    return uploadImageToFirebase(file).then(async (ref) => {
      setImageRef(ref);
      const url = await ref.getDownloadURL();
      setImageUrl(url);
    });
  };
  const handleImageDelete = () => {
    if (imageRef) {
      imageRef.delete().then(() => {
        setImageUrl(null);
        setImageRef(null);
      });
    }
  };
  const customUpload = {
    name: "image",
    action: "",
    beforeUpload: (file) => {
      handleImageUpload(file);
      return false;
    },
    onRemove: handleImageDelete,
  };

  const validateMessages = {
    required: " is required!",
    types: {
      email: " ingrese un correo válido!",
      number: " is not a valid number!",
    },
  };
  return (
    <div>
      <Layout className="layout-default layout-signin">
        <Header>
          <div className="header-col header-brand">
            <a
              href="https://kameliapp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="msoft" height={"auto"} width={"20%"} />
            </a>
          </div>
          <div className="header-col header-nav"></div>
          <div className="header-col header-btn">
            <Button
              color="black"
              style={{ backgroudColor: "var(--secondary)" }}
              onClick={() =>
                window.open("https://kameliapp.com/precios/", "_blank")
              }
            >
              Ver precios
            </Button>
          </div>
        </Header>
        <Row style={{ marginTop: "50px" }}>
          <Col span={12} offset={6}>
            <Form
              onFinish={onFinish}
              layout="vertical"
              validateMessages={validateMessages}
            >
              <Upload {...customUpload}>
                <Button icon={<UploadOutlined />}>
                  Click para subir la gráfica
                </Button>
                {imageUrl && <img src={imageUrl} alt="Uploaded" />}
              </Upload>

              <Form.Item
                label="Felicitaciones por su buen hábito"
                rules={[
                  {
                    required: true,
                  },
                ]}
                name="good"
              >
                <Select placeholder="Felicitaciones por su buen hábito">
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de sueño, recuerda dormir más de 7 horas y menos 8 horas y tomar un vaso agua cuando te levantes para iniciar con la mejor energía.">
                    Calidad de sueño
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de Productividad">
                    {" "}
                    Productividad
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de Ansiedad/ estrés">
                    {" "}
                    Ansiedad/ estrés
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de hábitos alimenticios">
                    {" "}
                    Hábitos alimenticios
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de vida sentimental">
                    {" "}
                    Vida sentimental
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de Actividad física">
                    {" "}
                    Actividad física
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Hábito por mejorar"
                rules={[{ required: true }]}
                name="bad"
              >
                <Select placeholder="Hábito por mejorar">
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de sueño, recuerda dormir más de 7 horas y menos 8 horas y tomar un vaso agua cuando te levantes para iniciar con la mejor energía.">
                    Calidad de sueño
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de Productividad">
                    {" "}
                    Productividad
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de Ansiedad/ estrés">
                    {" "}
                    Ansiedad/ estrés
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de hábitos alimenticios">
                    {" "}
                    Hábitos alimenticios
                  </Option>
                  <Option value="😁 Sigue manteniendo tus buenos hábitos de vida sentimental">
                    {" "}
                    Vida sentimental
                  </Option>
                  <Option value="📊 Cómo puedes observar, te recomendamos mejorar en tu actividad física. Si Incluyes ejercicios 🏃🏼‍♀️en su rutina diaria puede ayudarte a mejorar esta área y reducir el estrés.">
                    {" "}
                    Actividad física
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Test de ansiedad"
                rules={[{ required: true }]}
                name="level"
              >
                <Select placeholder="Test de ansiedad">
                  <Option value="No se aprecia ansiedad">
                    De 0-4 No se aprecia ansiedad{" "}
                  </Option>

                  <Option value="leve">
                    De 5-9 Se aprecian síntomas de ansiedad leves{" "}
                  </Option>

                  <Option value="moderada">
                    De 10-14 Se aprecian síntomas de ansiedad moderados{" "}
                  </Option>

                  <Option value="alta">
                    De 15-21 Se aprecian síntomas de ansiedad severos{" "}
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Mensaje de ansiedad"
                rules={[{ required: true }]}
                name="anxiety"
              >
                <Select placeholder="Mensaje de acuerdo a test de ansiedad">
                  <Option value="No se aprecia ansiedad">
                    No se aprecia ansiedad{" "}
                  </Option>

                  <Option value="leve">Leve </Option>

                  <Option value="moderada">Moderado </Option>

                  <Option value="alta">Severo </Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ type: "email", required: true }]}
              >
                <Input />
              </Form.Item>
              <Button htmlType="submit">Guardar</Button>
            </Form>
          </Col>
        </Row>
      </Layout>
    </div>
  );
};

export { UpTest };
